export default __webpack_public_path__ + "static/media/photo-charte08.b26f94f1.png";